<ng-container *ngIf="showWorm">
    <div class="inline-flex-wrapper mb-15" *ngIf="!isSimpleMode">
        <!-- SNAP开关 -->
        <h3 class="title-md">{{i18n.create.wormTab}}</h3>
        <n-switch *ngIf="!data"
            id="cdp_create_wormenabled"
            [(ngModel)]="wormEnabled"
            (onChange)="wormEnabledChange($event)">
        </n-switch>
    </div>
    <form [formGroup]="vm" [simpleMode]="isSimpleMode"
        [errorMessage]="errorMessage">
        <ng-container *ngIf="wormEnabled">
            <n-form-item [label]="i18n.create.protectTime">
                <!-- 最小保护期 -->
                <n-spinner style="width:2.66rem"
                    [onlyInput]="true"
                    [precision]="0"
                    [min]="protectPeriodRangeE.min"
                    [max]="protectPeriodMax.lun"
                    formControlName="PROTECTPERIOD"
                    id="cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.create.protectPeriodRangeLabel | fn :protectPeriodRangeE.min :protectPeriodMax.lun}}</span>
                <!-- 最小保护期 单位-->
                <n-select style="width:1.2rem"
                    class="ml-10"
                    [options]="protectPeriodOptions"
                    formControlName="PROTECTPERIODUNIT"
                    (onChange)="unitChanged($event, 'lun')"
                    id="cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>
            <!-- 自动删除 -->
            <n-form-item [label]="i18n.create.enableAutoDelete">
                <n-checkbox
                    [label]="i18n.create.enableLab"
                    id="cdp_create_auto_delete"
                    formControlName="AUTODELETEENABLED">
                </n-checkbox>
                <p class="sub mt-10">{{i18n.create.autoDeleteInfo}}</p>
            </n-form-item>
        </ng-container>
    </form>
</ng-container>

<h3 class="title-md mb-15">{{i18n.title.fixedPeriod}}</h3>
<form [formGroup]="vm" [simpleMode]="isSimpleMode"
    [errorMessage]="errorMessage">
    <!-- 固定周期 -->
    <n-form-item [colon]="false">
        <!-- 每 -->
        <n-checkbox id="hyper-cdp-schedule-create-config-policy-isfixed"
            labelExtend
            [label]="i18n.title.every"
            formControlName="isFixed"
            (onChange)="onStrategyChange()">
        </n-checkbox>

        <div class="interval-10" formGroupName="fixed">
            <!-- 秒 -->
            <n-spinner
                *ngIf="vm.get('fixed.timeUnit').value === 'second'"
                id="hyper-cdp-schedule-create-config-policy-fixed-second-id"
                style="width: .95rem;"
                [onlyInput]="true"
                [min]="minSecond"
                [max]="59"
                formControlName="second">
            </n-spinner>
            <span *ngIf="vm.get('fixed.timeUnit').value === 'second'">
                {{i18n.title.rangeResult(minSecond,59)}}
            </span>

            <!-- 分钟 -->
            <n-spinner
                *ngIf="vm.get('fixed.timeUnit').value === 'minute'"
                id="hyper-cdp-schedule-create-config-policy-fixed-minute-id"
                style="width: .95rem;"
                [onlyInput]="true"
                [min]="minuteMin"
                [max]="1440"
                formControlName="minute">
            </n-spinner>
            <span *ngIf="vm.get('fixed.timeUnit').value === 'minute'">
                {{i18n.title.rangeResult(minuteMin,1440)}}
            </span>

            <!-- 小时 -->
            <n-spinner
                *ngIf="vm.get('fixed.timeUnit').value === 'hour'"
                id="hyper-cdp-schedule-create-config-policy-fixed-hour-id"
                style="width: .95rem;"
                [onlyInput]="true"
                [min]="1"
                [max]="24"
                formControlName="hour">
            </n-spinner>
            <span *ngIf="vm.get('fixed.timeUnit').value === 'hour'">
                {{i18n.title.rangeResult(1,24)}}
            </span>

            <!-- 单位切换 -->
            <n-select id="hyper-cdp-schedule-create-config-policy-fixed-time-unit"
                style="width: 1.45rem;"
                [options]="everyOpts"
                formControlName="timeUnit">
            </n-select>
        </div>
    </n-form-item>
    <ng-container *ngIf="!isSimpleMode && type === ScheduleTypeE.File && vm.value.isFixed" formGroupName="fixed">
        <n-form-item [label]="i18n.create.wormTab">
            <n-switch id="fixed-securesnape-switch"
                formControlName="FREQUENCYSECURESNAPENABLED"
                (onChange)="securityEnabledChange($event, 'per')">
            </n-switch>
        </n-form-item>
        <ng-container *ngIf="vm.value.isFixed && vm.get('fixed.FREQUENCYSECURESNAPENABLED').value">
            <n-form-item [label]="i18n.create.protectTime">
                <!-- 最小保护期 -->
                <n-spinner style="width:2.66rem"
                    [onlyInput]="true"
                    [precision]="0"
                    [min]="protectPeriodRangeE.min"
                    [max]="protectPeriodMax.per"
                    formControlName="FREQUENCYPROTECTPERIOD"
                    id="fixed_cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.create.protectPeriodRangeLabel | fn :protectPeriodRangeE.min :protectPeriodMax.per}}</span>
                <!-- 最小保护期 单位-->
                <n-select style="width:1.2rem"
                    class="ml-10"
                    [options]="protectPeriodOptions"
                    formControlName="FREQUENCYPERIODUNIT"
                    (onChange)="unitChanged($event, 'per')"
                    id="fixed_cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>
            <n-form-item [label]="i18n.create.enableAutoDelete">
                <n-checkbox
                    [label]="i18n.create.enableLab"
                    id="fixed_cdp_create_auto_delete"
                    formControlName="FREQUENCYAUTODELETEENABLED">
                </n-checkbox>
                <p class="sub mt-10" [innerHTML]="data ? i18n.modify.autoDeleteInfo : i18n.create.autoDeleteInfo"></p>
            </n-form-item>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="((type === ScheduleTypeE.File && !vm.get('fixed.FREQUENCYSECURESNAPENABLED').value) || (type === ScheduleTypeE.Block && !wormEnabled)) && vm.value.isFixed"
        formGroupName="fixed">
        <n-form-item [labelHide]="true">
            <h3 style="font-size: .14rem;">{{i18n.title.retention}}</h3>
        </n-form-item>
        <n-form-item [label]="i18n.title.everyByTime"
            [required]="true"
            [helpContent]="i18n.title.retentionTimeTip">
            <div class="by-time-control">
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-fixed-retention-day"
                    style="width: .95rem"
                    [onlyInput]="true"
                    [min]="0"
                    [max]="60000"
                    formControlName="retentionDay">
                </n-spinner>
                <span>{{i18n.title.days}}</span>
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-fixed-retention-hour"
                    style="width: .95rem"
                    [onlyInput]="true"
                    [min]="0"
                    [max]="23"
                    formControlName="retentionHour">
                </n-spinner>
                <span>{{i18n.title.hour}}</span>
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-fixed-retention-minute"
                    style="width: .95rem"
                    [onlyInput]="true"
                    [min]="0"
                    [max]="59"
                    formControlName="retentionMinute">
                </n-spinner>
                <span>{{i18n.title.minute}}</span>
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-fixed-retention-second"
                    style="width: .95rem"
                    [onlyInput]="true"
                    [min]="0"
                    [max]="59"
                    formControlName="retentionSecond">
                </n-spinner>
                <span>{{i18n.title.second}}</span>
            </div>
        </n-form-item>
        <n-form-item [label]="i18n.title.everyByCount"
            [required]="true"
            [helpContent]="retentionNumTip">
            <div class="interval-10">
                <!-- 按个数 -->
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-fixed-retention-num"
                    style="width: .95rem;"
                    [onlyInput]="true"
                    [min]="1"
                    [max]="fixedMaxNum"
                    formControlName="retentionNum">
                </n-spinner>
                <span>{{fixedMaxNumTips}}</span>
            </div>
        </n-form-item>
    </ng-container>
    <!-- 标签设置 -->
    <ng-container *ngIf="!isSimpleMode && type === ScheduleTypeE.File && vm.value.isFixed" formGroupName="fixed">
        <n-form-item [label]="i18n.title.snapshotTag" [helpContent]="i18n.title.snapshotTagTip" *ngIf="!isSimpleMode" >
            <input type="text"
                class="snapshot"
                id="hyper-cdp-schedule-create-config-policy-fixed-retention-snapTag-frequencytag"
                nInput
                [placeholder]="placeholderSnapTag"
                formControlName="FREQUENCYTAG">
        </n-form-item>
    </ng-container>
</form>

<h3 class="title-md mb-15">{{i18n.title.specificTime}}</h3>
<form [formGroup]="vm" [simpleMode]="isSimpleMode"
    [errorMessage]="errorMessage">
    <n-form-item [labelHide]="true">
        <n-checkbox id="hyper-cdp-schedule-create-config-policy-daily"
            [label]="i18n.title.daily"
            formControlName="isDaily"
            (onChange)="onStrategyChange()">
        </n-checkbox>
    </n-form-item>
    <ng-container *ngIf="type === ScheduleTypeE.File && vm.value.isDaily" formGroupName="daily">
        <n-form-item [label]="i18n.create.wormTab" *ngIf="!isSimpleMode">
            <n-switch id="day-securesnape-switch"
                formControlName="DAYSECURESNAPENABLED"
                (onChange)="securityEnabledChange($event, 'day')">
            </n-switch>
        </n-form-item>
        <ng-container *ngIf="vm.value.isDaily && vm.get('daily.DAYSECURESNAPENABLED').value && !isSimpleMode">
            <n-form-item [label]="i18n.create.protectTime">
                <!-- 最小保护期 -->
                <n-spinner style="width:2.66rem"
                    [onlyInput]="true"
                    [precision]="0"
                    [min]="protectPeriodRangeE.min"
                    [max]="protectPeriodMax.day"
                    formControlName="DAYPROTECTIONPERIOD"
                    id="day_cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.create.protectPeriodRangeLabel | fn :protectPeriodRangeE.min :protectPeriodMax.day}}</span>
                <!-- 最小保护期 单位-->
                <n-select style="width:1.2rem"
                    class="ml-10"
                    [options]="protectPeriodOptions"
                    formControlName="DAYPERIODUNIT"
                    (onChange)="unitChanged($event, 'day')"
                    id="day_cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>
            <n-form-item [label]="i18n.create.enableAutoDelete">
                <n-checkbox
                    [label]="i18n.create.enableLab"
                    id="day_cdp_create_auto_delete"
                    formControlName="DAYAUTODELETEENABLED">
                </n-checkbox>
                <p class="sub mt-10" [innerHTML]="data ? i18n.modify.autoDeleteInfo : i18n.create.autoDeleteInfo"></p>
            </n-form-item>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="vm.value.isDaily" formGroupName="daily">
        <n-form-item [label]="i18n.title.hourLabel" [required]="true">
            <n-checkbox-group
                id="hyper-cdp-schedule-create-config-policy-daily-hours"
                class="hour-list"
                formControlName="hours">
                <n-checkbox *ngFor="let item of hourList"
                    [label]="item.label"
                    [value]="item.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
        <n-form-item [label]="i18n.title.minuteLabel" [required]="true">
            <div class="interval-10">
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-daily-minute"
                    [onlyInput]="true"
                    style="width: 1.45rem;"
                    [min]="0"
                    [max]="59"
                    formControlName="minute">
                </n-spinner>
                <span>{{i18n.title.rangeResult(0,59)}}</span>
            </div>
        </n-form-item>
        <n-form-item *ngIf="(type === ScheduleTypeE.File && !vm.get('daily.DAYSECURESNAPENABLED').value) || (type === ScheduleTypeE.Block && !wormEnabled)"
            [label]="i18n.title.retainedNumber"
            [required]="true">
            <div class="interval-10">
                <!-- 每天-单个成员保留个数 -->
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-daily-retention-num"
                    [onlyInput]="true"
                    style="width: 1.45rem;"
                    [min]="1"
                    [max]="dailyMaxNum"
                    formControlName="retentionNum">
                </n-spinner>
                <span>{{i18n.title.rangeResult(1,dailyMaxNum)}}</span>
            </div>
        </n-form-item>
        <!-- 标签设置 -->
        <n-form-item *ngIf="!isSimpleMode && type === ScheduleTypeE.File" [label]="i18n.title.snapshotTag" [helpContent]="i18n.title.snapshotTagTip">
            <input type="text"
                class="snapshot"
                id="hyper-cdp-schedule-create-config-policy-fixed-retention-snapTag-daytag"
                nInput
                [placeholder]="placeholderSnapTag"
                formControlName="DAYTAG">
        </n-form-item>
    </ng-container>

    <n-form-item [labelHide]="true">
        <n-checkbox id="hyper-cdp-schedule-create-config-policy-weekly"
            [label]="i18n.title.weekly"
            formControlName="isWeekly"
            (onChange)="onStrategyChange()">
        </n-checkbox>
    </n-form-item>
    <ng-container *ngIf="type === ScheduleTypeE.File && vm.value.isWeekly" formGroupName="weekly">
        <n-form-item [label]="i18n.create.wormTab" *ngIf="!isSimpleMode">
            <n-switch id="week-securesnape-switch"
                formControlName="WEEKLYSECURESNAPENABLED"
                (onChange)="securityEnabledChange($event, 'week')">
            </n-switch>
        </n-form-item>
        <ng-container *ngIf="vm.value.isWeekly && vm.get('weekly.WEEKLYSECURESNAPENABLED').value && !isSimpleMode">
            <n-form-item [label]="i18n.create.protectTime">
                <!-- 最小保护期 -->
                <n-spinner style="width:2.66rem"
                    [onlyInput]="true"
                    [precision]="0"
                    [min]="protectPeriodRangeE.min"
                    [max]="protectPeriodMax.week"
                    formControlName="WEEKLYPROTECTIONPERIOD"
                    id="week_cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.create.protectPeriodRangeLabel | fn :protectPeriodRangeE.min :protectPeriodMax.week}}</span>
                <!-- 最小保护期 单位-->
                <n-select style="width:1.2rem"
                    class="ml-10"
                    [options]="protectPeriodOptions"
                    formControlName="WEEKLYPERIODUNIT"
                    (onChange)="unitChanged($event, 'week')"
                    id="week_cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>
            <n-form-item [label]="i18n.create.enableAutoDelete">
                <n-checkbox
                    [label]="i18n.create.enableLab"
                    id="week_cdp_create_auto_delete"
                    formControlName="WEEKLYAUTODELETEENABLED">
                </n-checkbox>
                <p class="sub mt-10" [innerHTML]="data ? i18n.modify.autoDeleteInfo : i18n.create.autoDeleteInfo"></p>
            </n-form-item>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="vm.value.isWeekly" formGroupName="weekly">
        <n-form-item [label]="i18n.title.week" [required]="true">
            <n-checkbox-group
                id="hyper-cdp-schedule-create-config-policy-weekly-days"
                formControlName="days">
                <n-checkbox
                    *ngFor="let item of dateOpt"
                    [label]="item.label"
                    style="width: 60px;"
                    [value]="item.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
        <n-form-item [label]="i18n.title.time" [required]="true">
            <n-time id="hyper-cdp-schedule-create-config-policy-weekly-time"
                formControlName="time"
                [showSeconds]="false">
            </n-time>
        </n-form-item>
        <n-form-item *ngIf="type === ScheduleTypeE.File && !vm.get('weekly.WEEKLYSECURESNAPENABLED').value || type === ScheduleTypeE.Block && !wormEnabled"
            [label]="i18n.title.retainedNumber"
            [required]="true">
            <div class="interval-10">
                <!-- 每周-单个成员保留个数 -->
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-weekly-retention-num"
                    [onlyInput]="true"
                    style="width: 1.45rem;"
                    [min]="1"
                    [max]="weeklyMaxNum"
                    formControlName="retentionNum">
                </n-spinner>
                <span>{{i18n.title.rangeResult(1,weeklyMaxNum)}}</span>
            </div>
        </n-form-item>
        <!-- 标签设置 -->
        <n-form-item *ngIf="!isSimpleMode && type === ScheduleTypeE.File" [label]="i18n.title.snapshotTag" [helpContent]="i18n.title.snapshotTagTip">
            <input type="text"
                class="snapshot"
                id="hyper-cdp-schedule-create-config-policy-fixed-retention-snapTag-weeklytag"
                nInput
                [placeholder]="placeholderSnapTag"
                formControlName="WEEKLYTAG">
        </n-form-item>
    </ng-container>

    <n-form-item [labelHide]="true">
        <n-checkbox id="hyper-cdp-schedule-create-config-policy-monthly"
            [label]="i18n.title.monthly"
            formControlName="isMonthly"
            (onChange)="onStrategyChange()">
        </n-checkbox>
    </n-form-item>
    <ng-container *ngIf="type === ScheduleTypeE.File && vm.value.isMonthly" formGroupName="monthly">
        <n-form-item [label]="i18n.create.wormTab" *ngIf="!isSimpleMode">
            <n-switch id="month-securesnape-switch"
                formControlName="MONTHSECURESNAPENABLED"
                (onChange)="securityEnabledChange($event, 'month')">
            </n-switch>
        </n-form-item>
        <ng-container *ngIf="vm.value.isMonthly && vm.get('monthly.MONTHSECURESNAPENABLED').value && !isSimpleMode">
            <n-form-item [label]="i18n.create.protectTime">
                <!-- 最小保护期 -->
                <n-spinner style="width:2.66rem"
                    [onlyInput]="true"
                    [precision]="0"
                    [min]="protectPeriodRangeE.min"
                    [max]="protectPeriodMax.month"
                    formControlName="MONTHPROTECTIONPERIOD"
                    id="month_cdp_create_protect_period">
                </n-spinner>
                <span class="ml-10">{{i18n.create.protectPeriodRangeLabel | fn :protectPeriodRangeE.min :protectPeriodMax.month}}</span>
                <!-- 最小保护期单位 -->
                <n-select style="width:1.2rem"
                    class="ml-10"
                    [options]="protectPeriodOptions"
                    formControlName="MONTHPERIODUNIT"
                    (onChange)="unitChanged($event, 'month')"
                    id="month_cdp_create_protect_period_unit">
                </n-select>
            </n-form-item>
            <n-form-item [label]="i18n.create.enableAutoDelete">
                <n-checkbox
                    [label]="i18n.create.enableLab"
                    id="month_cdp_create_auto_delete"
                    formControlName="MONTHAUTODELETEENABLED">
                </n-checkbox>
                <p class="sub mt-10" [innerHTML]="data ? i18n.modify.autoDeleteInfo : i18n.create.autoDeleteInfo"></p>
            </n-form-item>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="vm.value.isMonthly" formGroupName="monthly">
        <n-form-item [label]="i18n.title.date" [required]="true">
            <n-day-select id="hyper-cdp-schedule-create-config-policy-monthly-days"
                style="width: 3rem;"
                formControlName="days">
            </n-day-select>
        </n-form-item>
        <n-form-item [label]="i18n.title.time" [required]="true">
            <n-time id="hyper-cdp-schedule-create-config-policy-monthly-time"
                formControlName="time"
                [showSeconds]="false">
            </n-time>
        </n-form-item>
        <n-form-item *ngIf="type === ScheduleTypeE.File && !vm.get('monthly.MONTHSECURESNAPENABLED').value || type === ScheduleTypeE.Block && !wormEnabled"
            [label]="i18n.title.retainedNumber"
            [required]="true">
            <div class="interval-10">
                <!-- 每月-单个成员保留个数 -->
                <n-spinner
                    id="hyper-cdp-schedule-create-config-policy-monthly-retention-num"
                    style="width: 1.45rem;"
                    [onlyInput]="true"
                    [min]="1"
                    [max]="monthlyMaxNum"
                    formControlName="retentionNum">
                </n-spinner>
                <span>{{i18n.title.rangeResult(1, monthlyMaxNum)}}</span>
            </div>
        </n-form-item>
        <!-- 标签设置 -->
        <n-form-item *ngIf="!isSimpleMode && type === ScheduleTypeE.File" [label]="i18n.title.snapshotTag" [helpContent]="i18n.title.snapshotTagTip">
            <input type="text"
                class="snapshot"
                id="hyper-cdp-schedule-create-config-policy-fixed-retention-snapTag-monthtag"
                nInput
                [placeholder]="placeholderSnapTag"
                formControlName="MONTHTAG">
        </n-form-item>
    </ng-container>
</form>

<n-tip type="failed"
    *ngIf="atLeastOneCdpSchedule"
    [content]="i18n.atLeastOneCdpSchedule">
</n-tip>
